import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'gwc-frontend-layout',
    templateUrl: './forms-layout.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FormsLayoutComponent implements OnInit {

	public env: { [key: string]: string } | null = null

	/**
	 * Constructor
	 */
	constructor(
		private _activatedRoute: ActivatedRoute
	) { }

	
	//--------------------------------------------------------------------------------
	// @Accessors
	//--------------------------------------------------------------------------------
	ngOnInit(): void {
	
		this._activatedRoute.data.subscribe({
			next: (data: any ) => {
				this.env = data.env

			}
		})

	}

}


